import { vec3 } from 'gl-matrix';

import { type Vector3 as Vector3Interface, type Matrix } from '@canvas/vector-types';

/**
 * @deprecated
 */
export class Vector3 implements Vector3Interface {
  public readonly type = 'Vector3';

  /**
   * @deprecated use vec3 from gl-matrix instead when possible
   */
  public constructor(public x: number, public y: number, public z: number) {}

  public multiply(matrix: Matrix) {
    // prettier-ignore
    const [
      m00, m01, m02,
      m10, m11, m12,
      m20, m21, m22
    ] = matrix.toArray();

    return new Vector3(
      m00 * this.x + m10 * this.y + m20 * this.z,
      m01 * this.y + m11 * this.y + m21 * this.z,
      m02 * this.x + m12 * this.y + m22 * this.z
    );
  }

  static fromJSON(data: unknown) {
    if (
      // Ensure the data is not null, undefined, or a primitive
      data == null ||
      typeof data !== 'object' ||
      // Ensure the array has at least two elements
      !('0' in data) ||
      !('1' in data) ||
      !('2' in data) ||
      // Ensure the elements are numbers
      typeof data[0] !== 'number' ||
      typeof data[1] !== 'number' ||
      typeof data[2] !== 'number' ||
      // Ensure the elements are not NaN
      isNaN(data[0]) ||
      isNaN(data[1]) ||
      isNaN(data[2])
    ) {
      // Return a zero vector if the data is invalid
      return new Vector3(0, 0, 0);
    }

    return new Vector3(data[0], data[1], data[2]);
  }

  static fromHexColor(color: string) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);

    return new Vector3(r, g, b);
  }

  public toArray(): vec3 {
    return vec3.fromValues(this.x, this.y, this.z);
  }

  public toGPUColor(): Vector3 {
    return new Vector3(this.x / 255, this.y / 255, this.z / 255);
  }

  public toString(format: 'rgb'): string;
  public toString(format?: 'rgb') {
    if (format === 'rgb') {
      return `rgb(${[this.x, this.y, this.z].join(',')})`;
    }
  }
}

export const Color = Vector3;
export type Color = Vector3;

export const emptyVector3 = new Vector3(0, 0, 0);

export const isVector3 = (item: Vector3): item is Vector3 => {
  return !!item && item.type === 'Vector3';
};
